import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import { getCookie__c } from "../plugins/cookies";
import Store from "../store"
import RSPMonthlyProgressList from "@/views/ProjectManagement/RSPMonthlyProgressList.vue";
import Calendar from "@/views/Calendar/index.vue";

const spaceRequestsPreview = () =>
  import("../views/spaceRequestsManagement/spaceRequestsPreview.vue");
const spaceRequestsForm = () =>
  import("../views/spaceRequestsManagement/spaceRequestsForm.vue");
const spaceRequestsList = () =>
  import("../views/spaceRequestsManagement/spaceRequestsList.vue");
const spaceRequestsAll = () =>
  import("../views/spaceRequestsManagement/spaceRequestsAll.vue");
const spaceRequestsOffer = () =>
  import("../views/spaceRequestsManagement/spaceRequestsOffer.vue");
const spaceRequestsRSP = () =>
  import("../views/spaceRequestsManagement/spaceRequestsRSP.vue");
const spiderChart = () =>
  import("../views/spaceRequestsManagement/spiderChart.vue");
const spiderChartForm = () =>
  import("../views/spaceRequestsManagement/SpiderChartForm.vue");
const spiderChartPreview = () =>
  import("../views/spaceRequestsManagement/SpiderChartPreview.vue");
const RequirementForm = () =>
  import("../views/RequirementForm/RequirementForm");
const RequirementList = () =>
  import("../views/RequirementForm/RequirementList");
const RequirementPreview = () =>
  import("../views/RequirementForm/RequirementPreview");
const MainProject = () => import("../views/ProjectManagement/MainProject");
const MainProjectOffer = () =>
  import("../views/ProjectManagement/MainProjectOffer");
const MainProjectForm = () =>
  import("../views/ProjectManagement/MainProjectForm");
const ConsiderFormList = () =>
  import("../views/ProjectManagement/ConsiderFormList");
const ProjectOfferFromRSP = () =>
  import("../views/ProjectManagement/ProjectOfferFromRSP");
const AvailablePlan = () => import("../views/ProjectManagement/AvailablePlan");
const AvailablePlanList = () =>
  import("../views/ProjectManagement/AvailablePlanList");
const AvailablePlanListEdit = () =>
  import("../views/ProjectManagement/AvailablePlanListEdit");
const PlanOfferList = () => import("../views/ProjectManagement/PlanOfferList");
const AllocatedProjectList = () =>
  import("../views/ProjectManagement/AllocatedProjectList");
const ProgressFollowed = () =>
  import("../views/ProjectManagement/ProgressFollowed");
const MonthlyProgressList = () =>
  import("../views/ProjectManagement/MonthlyProgressList");
const MonthlyProgressForm = () =>
  import("../views/ProjectManagement/MonthlyProgressForm");
const ProgressReportList = () =>
  import("../views/ProjectManagement/ProgressReportList");
const ReportFromRSPList = () =>
  import("../views/ProjectManagement/ReportFromRSPList");
const ProgressReportOfferList = () =>
  import("../views/ProjectManagement/ProgressReportOfferList");
const FormA = () => import("../views/ProjectManagement/FormA");
const FormB = () => import("../views/ProjectManagement/FormB");
const FormC = () => import("../views/ProjectManagement/FormC");
const FormD = () => import("../views/ProjectManagement/FormD");
const FormF = () => import("../views/ProjectManagement/FormF");
const Dashboard = () => import("../views/dashboard/Dashboard");
const ConsiderForm = () => import("../views/ProjectManagement/ConsiderForm");
const ConsiderResult = () =>
  import("../views/ProjectManagement/ConsiderResult");
const ConsiderResultAF = () =>
  import("../views/ProjectManagement/ConsiderResultAF");
const EvaluateForm = () => import("../views/ProjectManagement/EvaluateForm");
const EvaluateView = () => import("../views/ProjectManagement/EvaluateView");
const EvaluateList = () => import("../views/ProjectManagement/EvaluateList");
const EvaluateRequest = () => import("../views/ProjectManagement/EvaluateRequest");

const USPExtendTimeList = () =>
  import("../views/ProjectManagement/ExtendTime/USP/Index");
const USPExtendTimeForm = () =>
  import("../views/ProjectManagement/ExtendTime/USP/Form");
const USPExtendTimeDetail = () =>
  import("../views/ProjectManagement/ExtendTime/USP/Detail");

const SPExtendTimeList = () =>
  import("../views/ProjectManagement/ExtendTime/SP/Index");
const SPExtendTimeForm = () =>
  import("../views/ProjectManagement/ExtendTime/SP/Form");
const SPExtendTimeDetail = () =>
  import("../views/ProjectManagement/ExtendTime/SP/Detail");

const RSPExtendTimeList = () =>
  import("../views/ProjectManagement/ExtendTime/RSP/Index");
const RSPExtendTimeForm = () =>
  import("../views/ProjectManagement/ExtendTime/RSP/Form");
const RSPExtendTimeDetail = () =>
  import("../views/ProjectManagement/ExtendTime/RSP/Detail");

// auth
const UserList = () => import("../views/Auth/User/Index");
const UserForm = () => import("../views/Auth/User/Form");
const LogActivity = () => import("../views/Auth/LogActivity/Index");

const UserServiceHistory = () => import("../views/UserServiceHistory/index.vue")
const UserServiceHistoryCreate = () => import("../views/UserServiceHistory/create.vue")
const UserServiceHistoryId = () => import("../views/UserServiceHistory/id.vue")
const UserServiceHistoryEdit = () => import("../views/UserServiceHistory/edit.vue")

//calendar activity
const CalendarActivity = () => import("../views/CalendarActivity/index.vue")
const CalendarActivityCreate = () => import("../views/CalendarActivity/create.vue")
const CalendarActivityEdit = () => import("../views/CalendarActivity/id.vue")

const TechnologyEvaluation = () => import("../views/TechnologyEvaluation/index.vue")
const TechnologyEvaluationCreate = () => import("../views/TechnologyEvaluation/create.vue")
const TechnologyEvaluationEdit = () => import("../views/TechnologyEvaluation/id.vue")

// fundamental
const ProgressFundamentalList = () => import("../views/ProjectManagement/ProgressFundamentalList.vue");
const ProgressFundamentalForm = () => import("../views/ProjectManagement/ProgressFundamentalForm.vue");

Vue.use(VueRouter);

// silence the rejection and make the promise resolve with the error instead
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requireRole: ["USP", "RSP", "สป.อว."]
    }
  },
  {
    path: "/requirement",
    name: "RequirementList",
    meta: {
      bcName: "Requirement Form",
      requireRole: ["USP", "RSP", "สป.อว.",'ผู้ประกอบการ']
    },
    component: RequirementList,
  },
  {
    path: "/requirement-form",
    name: "RequirementForm",
    meta: {
      parentName: "RequirementList",
      bcName: "แบบฟอร์มความต้องการเทคโนโลยี",
      requireRole: ["USP", "RSP", "สป.อว.",'ผู้ประกอบการ']
    },
    component: RequirementForm,
  },
  {
    path: "/requirement-form/:id",
    name: "RequirementForm",
    meta: {
      parentName: "RequirementList",
      bcName: "แบบฟอร์มความต้องการเทคโนโลยี",
      requireRole: ["USP", "RSP", "สป.อว.",'ผู้ประกอบการ']
    },
    component: RequirementForm,
  },
  {
    path: "/requirement-preview/:id",
    name: "RequirementPreview",
    meta: {
      parentName: "RequirementList",
      bcName: "แบบฟอร์มความต้องการเทคโนโลยี",
      requireRole: ["USP", "RSP", "สป.อว.",'ผู้ประกอบการ']
    },
    component: RequirementPreview,
  },
  {
    path: "/project-management",
    name: "ProjectManagement",
    meta: {
      bcName: "จัดการโครงการ",
      requireRole: ["USP", "RSP", "สป.อว."]
    },
    redirect: () => ({ name: "AvailablePlan" }),
  },
  {
    path: "/main-project",
    name: "MainProject",
    meta: {
      parentName: "ProjectManagement",
      bcName: "โครงการหลัก",
      requireRole: ["สป.อว."]
    },
    component: MainProject,
  },
  {
    path: "/main-project-form",
    name: "MainProjectForm",
    meta: {
      parentName: "MainProject",
      bcName: "แก้ไขข้อมูลโครงการหลัก",
      requireRole: ["สป.อว."]
    },
    component: MainProjectForm,
  },
  {
    path: "/main-project-form/:id",
    name: "MainProjectForm",
    meta: {
      parentName: "MainProject",
      bcName: "แก้ไขข้อมูลโครงการหลัก",
      requireRole: ["สป.อว."]
    },
    component: MainProjectForm,
  },
  {
    path: "/consider-form",
    name: "ConsiderFormList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "แบบฟอร์มพิจารณา",
      requireRole: ["สป.อว."]
    },
    component: ConsiderFormList,
  },
  {
    path: "/consider-form/form",
    name: "ConsiderForm",
    meta: {
      parentName: "ProjectManagement",
      bcName: "แบบฟอร์มพิจารณา",
      requireRole: ["สป.อว."]
    },
    component: ConsiderForm,
  },
  {
    path: "/consider-form/form/:id",
    name: "ConsiderFormEdit",
    meta: {
      parentName: "ProjectManagement",
      bcName: "แบบฟอร์มพิจารณา",
      requireRole: ["สป.อว."]
    },
    component: ConsiderForm,
  },
  {
    path: "/consider-result/form-b/:form_b_id",
    name: "ConsiderResult",
    meta: {
      parentName: "ProjectManagement",
      bcName: "แบบฟอร์มพิจารณา",
      requireRole: ["สป.อว."]
    },
    component: ConsiderResult,
  },
  {
    path: "/consider-result/area-form/:area_form_id",
    name: "ConsiderResultAF",
    meta: {
      parentName: "ProjectManagement",
      bcName: "แบบฟอร์มพิจารณา",
      requireRole: ["RSP","สป.อว."]
    },
    component: ConsiderResultAF,
  },
  {
    path: "/evaluate-form/:formType/:id", 
    name: "EvaluateForm",
    meta: {
      parentName: "EvaluateList",
      bcName: "แบบฟอร์มพิจารณาแผนงาน",
      requireRole: ["ผู้เชี่ยวชาญ"]
    },
    component: EvaluateForm,
  },
 
  {
    path: "/evaluate-list",
    name: "EvaluateList",
    meta: {
      bcName: "พิจารณาแผนงาน",
      requireRole: ["ผู้เชี่ยวชาญ"]
    },
    component: EvaluateList,
  },
  {
    path: "/evaluate-view/:id",
    name: "EvaluateView",
    meta: {
      parentName: "EvaluateList",
      bcName: "แบบฟอร์มพิจารณาแผนงาน",
      requireRole: ["ผู้เชี่ยวชาญ", "สป.อว.",'RSP']
    },
    component: EvaluateView,
  },
  {
    path: "/evaluate-request",
    name: "EvaluateRequest",
    meta: {
      bcName: "พิจารณาคำร้องขอใช้พื้นที่",
      requireRole: ["ผู้เชี่ยวชาญ"]
    },
    component: EvaluateRequest,
  },
  {
    path: "/available-plan",
    name: "AvailablePlan",
    meta: {
      parentName: "ProjectManagement",
      bcName: "แผนงานที่เปิดรับ",
      requireRole: ["USP", "RSP"]
    },
    component: AvailablePlan,
  },
  {
    path: "/available-plan-list",
    name: "AvailablePlanList",
    meta: {
      parentName: "AvailablePlan",
      bcName: "รายการแผนงานที่เปิดรับ",
      requireRole: ["USP", "RSP"]
    },
    component: AvailablePlanList,
  },
  {
    path: "/available-plan-edit",
    name: "AvailablePlanListEdit",
    meta: {
      parentName: "AvailablePlanList",
      bcName: "แก้ไข",
      requireRole: ["USP", "RSP"]
    },
    component: AvailablePlanListEdit,
  },
  {
    path: "/project-a-form",
    name: "FormA",
    meta: {
      parentName: "AvailablePlan",
      bcName: "รูปแบบข้อเสนอโครงการแผนงานหลัก",
      requireRole: ["RSP", "สป.อว."],
      showScrollProgress: true
    },
    component: FormA,
  },
  {
    path: "/project-b-form",
    name: "FormB",
    meta: {
      parentName: "MainProjectOffer",
      bcName: "สร้างแบบฟอร์ม",
      requireRole: ["RSP", "สป.อว.", "ผู้เชี่ยวชาญ"],
      showScrollProgress: true
    },
    component: FormB,
  },
  {
    path: "/project-c-form",
    name: "FormC",
    meta: {
      parentName: "AvailablePlan",
      bcName: "ยื่นโครงการ",
      requireRole: ["USP", "RSP", "สป.อว.", "ผู้เชี่ยวชาญ"],
      showScrollProgress: true
    },
    component: FormC,
  },
  {
    path: "/project-d-form",
    name: "FormD",
    meta: {
      parentName: "AvailablePlan",
      bcName: "ยื่นโครงการ",
      requireRole: ["USP", "RSP", "สป.อว.", "ผู้เชี่ยวชาญ"]
    },
    component: FormD,
  },
  {
    path: "/project-f-form",
    name: "FormF",
    meta: {
      parentName: "AvailablePlan",
      bcName: "ยื่นโครงการ",
      requireRole: ["USP", "RSP", "สป.อว.", "ผู้เชี่ยวชาญ"]
    },
    component: FormF,
  },
  {
    path: "/plan-offer",
    name: "PlanOfferList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "ข้อเสนอโครงการ",
      requireRole: ["USP", "RSP"]
    },
    component: PlanOfferList,
  },
  {
    path: "/allocated-project",
    name: "AllocatedProjectList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "โครงการที่ได้รับการจัดสรร",
      requireRole: ["USP"]
    },
    component: AllocatedProjectList,
  },
  {
    path: "/progress-follow",
    name: "ProgressFollowed",
    meta: {
      parentName: "ProjectManagement",
      bcName: "การติดตาม แบบ S-curve หรือ PBM ในทุกโครงการ",
      requireRole: ["RSP", "สป.อว."]
    },
    component: ProgressFollowed,
  },
  {
    path: "/monthly-progress",
    name: "MonthlyProgressList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "ติดตามความก้าวหน้า (รายเดือน)",
      requireRole: ["USP"]
    },
    component: MonthlyProgressList,
  },
  {
    path: "/rsp-monthly-progress",
    name: "RSPMonthlyProgressList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "ติดตามความก้าวหน้า (รายเดือน)",
      requireRole: ["RSP"]
    },
    component: RSPMonthlyProgressList,
  },
  {
    path: "/monthly-progress-info",
    name: "MonthlyProgressForm",
    meta: {
      parentName: "MonthlyProgressList",
      bcName: "รายงานผลดำเนินการ",
      requireRole: ["USP", "RSP"]
    },
    component: MonthlyProgressForm,
  },
  {
    path: "/project-offer",
    name: "MainProjectOffer",
    meta: {
      parentName: "ProjectManagement",
      bcName: "โครงการหลักที่ยื่นเสนอ สป.อว",
      requireRole: ["RSP"]
    },
    component: MainProjectOffer,
  },
  {
    path: "/offer-from-rsp",
    name: "ProjectOfferFromRSP",
    meta: {
      parentName: "ProjectManagement",
      bcName: "โครงการที่รับยื่นจาก RSP และผลพิจารณา",
      requireRole: ["สป.อว."]
    },
    component: ProjectOfferFromRSP,
  },
  {
    path: "/progress-report",
    name: "ProgressReportList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้า",
      requireRole: ["USP", "RSP"]
    },
    component: ProgressReportList,
  },
  {
    path: "/progress-report-offer",
    name: "ProgressReportOfferList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่ยื่น สป.อว.",
      requireRole: ["RSP"]
    },
    component: ProgressReportOfferList,
  },
  {
    path: "/report-from-rsp",
    name: "ReportFromRSPList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก RSP",
      requireRole: ["สป.อว."]
    },
    component: ReportFromRSPList,
  },

  // USP Extend Time
  {
    path: "/usp/extend-time",
    name: "USPExtendTimeList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "ยื่นขอขยายเวลา",
      requireRole: ["USP", "RSP"]
    },
    component: USPExtendTimeList,
  },
  {
    path: "/usp/extend-time/:form_c_id/form/",
    name: "USPExtendTimeFormCreate",
    meta: {
      parentName: "ProjectManagement",
      bcName: "แบบฟอร์มยื่นขอขยายเวลา",
      requireRole: ["USP", "RSP"]
    },
    component: USPExtendTimeForm,
  },
  {
    path: "/rsp/extend-time/:form_b_id/form/",
    name: "USPExtendTimeFormCreate",
    meta: {
      parentName: "ProjectManagement",
      bcName: "แบบฟอร์มยื่นขอขยายเวลา",
      requireRole: ["USP", "RSP"]
    },
    component: USPExtendTimeForm,
  },
  {
    path: "/usp/extend-time/:form_c_id/form/:id",
    name: "USPExtendTimeFormEdit",
    meta: {
      parentName: "ProjectManagement",
      bcName: "แบบฟอร์มยื่นขอขยายเวลา",
      requireRole: ["USP", "RSP"]
    },
    component: USPExtendTimeForm,
  },
  {
    path: "/rsp/extend-time/:form_b_id/form/:id",
    name: "USPExtendTimeFormEdit",
    meta: {
      parentName: "ProjectManagement",
      bcName: "แบบฟอร์มยื่นขอขยายเวลา",
      requireRole: ["USP", "RSP"]
    },
    component: USPExtendTimeForm,
  },
  {
    path: "/usp/extend-time/detail/:id",
    name: "USPExtendTimeDetail",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายละเอียดยื่นขอขยายเวลา",
      requireRole: ["USP", "RSP"]
    },
    component: USPExtendTimeDetail,
  },

  // RSP Extend Time
  {
    path: "/rsp/extend-time",
    name: "RSPExtendTimeList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "ยื่นขอขยายเวลา",
      requireRole: ["RSP"]
    },
    component: RSPExtendTimeList,
  },
  {
    path: "/rsp/extend-time/:pending_group_id/:plan_id/form",
    name: "RSPExtendTimeFormCreate",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก RSP",
      requireRole: ["RSP"]
    },
    component: RSPExtendTimeForm,
  },
  {
    path: "/rsp/extend-time/:pending_group_id/:plan_id/form/:id",
    name: "RSPExtendTimeFormEdit",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก RSP",
      requireRole: ["RSP"]
    },
    component: RSPExtendTimeForm,
  },
  {
    path: "/rsp/extend-time/detail/:id",
    name: "RSPExtendTimeDetail",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก RSP",
      requireRole: ["RSP"]
    },
    component: RSPExtendTimeDetail,
  },

  // SP Extend Time
  {
    path: "/sp/extend-time",
    name: "SPExtendTimeList",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก SP",
      requireRole: ["สป.อว."]
    },
    component: SPExtendTimeList,
  },
  {
    path: "/sp/extend-time/:pending_group_id/:plan_id/form",
    name: "SPExtendTimeFormCreate",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก SP",
      requireRole: ["สป.อว."]
    },
    component: SPExtendTimeForm,
  },
  {
    path: "/sp/extend-time/:pending_group_id/:plan_id/form/:id",
    name: "SPExtendTimeFormEdit",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก SP",
      requireRole: ["สป.อว."]
    },
    component: SPExtendTimeForm,
  },
  {
    path: "/sp/extend-time/detail/:id",
    name: "SPExtendTimeDetail",
    meta: {
      parentName: "ProjectManagement",
      bcName: "รายงานความก้าวหน้าที่รับยื่นจาก SP",
      requireRole: ["สป.อว."]
    },
    component: SPExtendTimeDetail,
  },

  {
    path: "/user-management",
    name: "UserManagement",
    component: UserList,
    meta: {
      requireRole: ["RSP", "สป.อว.", "Admin"]
    }
  },
  {
    path: "/user-management/form",
    name: "UserFormManagement",
    component: UserForm,
    meta: {
      requireRole: ["RSP", "สป.อว."]
    }
  },
  {
    path: "/user-management/form/:id",
    name: "UserFormEditManagement",
    component: UserForm,
    meta: {
      requireRole: ["RSP", "สป.อว."]
    }
  },
  {
    path: "/edit-profile",
    name: "EditProfile",
    component: UserForm,
    meta: {
      requireRole: ["USP"]
    }
  },
  {
    path: "/log-activity",
    name: "LogActivity",
    component: LogActivity,
    meta: {
      requireRole: ["RSP", "สป.อว."]
    }
  },
  {
    path: "/space-requests-management",
    name: "spaceRequestsManagement",
    meta: {
      bcName: "จัดการคำร้องขอใช้พื้นที่",
      requireRole: ["ผู้ประกอบการ", "RSP"]
    },
    redirect: () => ({ name: "spaceRequestsAll" }),
  },
  {
    path: "/space-requests-management/space-requests-all",
    name: "spaceRequestsAll",
    meta: {
      parentName: "spaceRequestsManagement",
      bcName: "แบบฟอร์มคำร้องขอใช้บริการพื้นที่ทั้งหมด",
      requireRole: ["ผู้ประกอบการ", "RSP"]
    },
    component: spaceRequestsAll,
    // redirect: () => ({ name: "spaceRequestsList" }),
  },
  {
    path: "/space-requests-management/space-requests-offer",
    name: "spaceRequestsOffer",
    meta: {
      parentName: "spaceRequestsManagement",
      bcName: "แบบฟอร์มที่ยื่นเสนอ สป.อว",
      requireRole: ["ผู้ประกอบการ", "RSP"]
    },
    component: spaceRequestsOffer,
    // redirect: () => ({ name: "spaceRequestsList" }),
  },
  {
    path: "/space-requests-management/space-requests-list",
    name: "spaceRequestsList",
    meta: {
      parentName: "spaceRequestsManagement",
      bcName: "แบบฟอร์มคำร้องขอใช้พื้นที่",
      requireRole: ["ผู้ประกอบการ", "RSP"]
    },
    component: spaceRequestsList,
  },
  {
    path: "/space-requests-management/space-requests-form",
    name: "spaceRequestsForm",
    component: spaceRequestsForm,
    meta: {
      parentName: "spaceRequestsManagement",
      bcName: "แบบฟอร์มคำร้องขอใช้พื้นที่",
      requireRole: ["ผู้ประกอบการ", "RSP"]
    }
  },
  {
    path: "/space-requests-management/space-requests-form/:id",
    name: "spaceRequestsForm",
    component: spaceRequestsForm,
    meta: {
      parentName: "spaceRequestsManagement",
      bcName: "แบบฟอร์มคำร้องขอใช้พื้นที่",
      requireRole: ["ผู้ประกอบการ", "RSP"]
    }
  },
  {
    path: "/space-requests-management/space-requests-preview/:id",
    name: "spaceRequestsPreview",
    meta: {
      parentName: "spaceRequestsManagement",
      bcName: "แบบฟอร์มคำร้องขอใช้พื้นที่",
      requireRole: ["ผู้ประกอบการ", "RSP"]
    },
   
    component: spaceRequestsPreview,
  },
  {
    path: "/space-requests-management/spider-chart/:id",
    name: "spiderChart",
    meta: {
      parentName: "spaceRequestsManagement",
      bcName: "",
      requireRole: ["ผู้ประกอบการ", "RSP"]
    },
    component: spiderChart,
  },
  {
    path: "/space-requests-management/space-requests-rsp",
    name: "spaceRequestsRSP",
    meta: {
      parentName: "spaceRequestsManagement",
      bcName: "แบบฟอร์มคำร้องขอใช้พื้นที่ จาก RSP",
      requireRole: ["สป.อว."]
    },
    component: spaceRequestsRSP,
    // redirect: () => ({ name: "spaceRequestsList" }),
  },
  {
    path: "/spider-chart/:id",
    name: "spiderChart",
    meta: {
      parentName: "",
      bcName: "spiderChart",
      requireRole: ["สป.อว."]
    },
    component: spiderChart,
    // redirect: () => ({ name: "spaceRequestsList" }),
  },
  {
    path: "/space-requests-management/spider-chart-form",
    name: "spiderChartForm",
    component: spiderChartForm,
    meta: {
      parentName: "spaceRequestsManagement",
      bcName: "แบบฟอร์มคำร้องขอใช้พื้นที่",
      requireRole: ["สป.อว.","RSP"]
    }
  },
  {
    path: "/space-requests-management/spider-chart-form/:id",
    name: "spiderChartFormEdit",
    component: spiderChartForm,
    meta: {
      parentName: "spaceRequestsManagement",
      bcName: "แบบฟอร์มคำร้องขอใช้พื้นที่",
      requireRole: ["สป.อว.","RSP"]
    }
  },
  {
    path: "/space-requests-management/spider-chart-preview/:id",
    name: "spiderChartPreview",
    component: spiderChartPreview,
    meta: {
      parentName: "spaceRequestsManagement",
      bcName: "แบบฟอร์มคำร้องขอใช้พื้นที่",
      requireRole: ["สป.อว.","RSP"]
    }
  },
  {
    path: "/user-service-history",
    name: "UserServiceHistory",
    component: UserServiceHistory,
    meta: {
      bcName: "ฐานข้อมูลประวัติผู้ใช้บริการ",
      requireRole: ["USP","RSP"]
    }
  },
  {
    path: "/user-service-history/create",
    name: "UserServiceHistoryCreate",
    component: UserServiceHistoryCreate,
    meta: {
      parentName: "UserServiceHistory",
      bcName: "แบบฟอร์มเพิ่มผู้ใช้บริการ",
      requireRole: ["USP","RSP"]

    }
  },
  {
    path: "/user-service-history/:id",
    name: "UserServiceHistoryId",
    component: UserServiceHistoryId,
    meta: {
      parentName: "UserServiceHistory",
      bcName: "รายการประวัติผู้ใช้บริการ",
      requireRole: ["USP","RSP"]

    }
  },
  {
    path: "/user-service-history/edit/:id",
    name: "UserServiceHistoryEdit",
    component: UserServiceHistoryEdit,
    meta: {
      parentName: "UserServiceHistory",
      bcName: "แบบฟอร์มแก้ไขผู้ใช้บริการ",
      requireRole: ["USP","RSP"]

    }
  },
  {
    path: "/calendar-activity",
    name: "CalendarActivity",
    component: CalendarActivity,
    meta: {
      bcName: "กิจกรรมปฏิทิน",
      requireRole: ["สป.อว.","RSP"]
      // requireRole: ["สป.อว.","RSP","USP"]
    }
  },
  {
    path: "/calendar-activity/create",
    name: "CalendarActivityCreate",
    component: CalendarActivityCreate,
    meta: {
      parentName: "CalendarActivity",
      bcName: "เพิ่มกิจกรรมปฏิทิน",
      requireRole: ["สป.อว.","RSP"]
      // requireRole: ["สป.อว.","RSP","USP"]
    }
  },
  {
    path: "/calendar-activity/:id/edit",
    name: "CalendarActivityEdit",
    component: CalendarActivityEdit,
    meta: {
      parentName: "CalendarActivity",
      bcName: "แก้ไขกิจกรรมปฏิทิน",
      requireRole: ["สป.อว.","RSP"]
      // requireRole: ["สป.อว.","RSP","USP"]
    }
  },
  {
    path: "/technology-evaluation",
    name: "TechnologyEvaluation",
    component: TechnologyEvaluation,
    meta: {
      bcName: "ระบบประเมินระดับเทคโนโลยี TCCL",
      requireRole: ["สป.อว.","RSP"]
    }
  },
    {
    path: "/technology-evaluation/create",
    name: "TechnologyEvaluationCreate",
    component: TechnologyEvaluationCreate,
    meta: {
      parentName: "TechnologyEvaluation",
      bcName: "ระบบประเมินระดับเทคโนโลยี TCCL",
      requireRole: ["สป.อว.","RSP"]
      // requireRole: ["สป.อว.","RSP","USP"]
    }
  },
  {
    path: "/technology-evaluation/:id/edit",
    name: "TechnologyEvaluationEdit",
    component: TechnologyEvaluationEdit,
    meta: {
      parentName: "TechnologyEvaluation",
      bcName: "ระบบประเมินระดับเทคโนโลยี TCCL",
      requireRole: ["สป.อว.","RSP"]
      // requireRole: ["สป.อว.","RSP","USP"]
    }
  },
  {
    path: "/progress-fundamental",
    name: "ProgressFundamentalList",
    component: ProgressFundamentalList,
    meta: {
      bcName: "ติดตามความก้าวหน้า โครงการที่รับทุน Fundamental Fund",
      requireRole: ["RSP", "USP", "สป.อว.", "Admin"]
    }
  },
  {
    path: "/progress-fundamental/form",
    name: "ProgressFundamentalForm",
    component: ProgressFundamentalForm,
    meta: {
      parentName: "ProgressFundamentalList",
      bcName: "แบบฟอร์มติดตามความก้าวหน้า",
      requireRole: ["RSP", "USP", "สป.อว.", "Admin"]
    }
  },
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        top: 0,
        behavior: "smooth",
      };
    }
  },
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth !== false)) {
    // if (!getCookie__c('sut_oss_session')) {
    //   console.log(4)
    //   if (from.name !== 'Login') {
    //     next({
    //       name: 'Login'
    //     })
    //   }
    // } else {
      // check user permissions
      let role = Store.state.Auth.User?.user_type
      if (role && to.meta.requireRole.includes(role)) {
        next();
      } else {
        if (role === 'ผู้เชี่ยวชาญ') {
          next({ name: 'EvaluateList' })
        } else if (role === 'ผู้ประกอบการ') {
          next({ name: 'spaceRequestsList' })
        }else {
          next({ name: 'Dashboard' })
        }
      }
    // }
  } else {
    next();
  }
});

export default router;
